import { render, staticRenderFns } from "./LivesOrder.vue?vue&type=template&id=197050e5&"
import script from "./LivesOrder.vue?vue&type=script&lang=js&"
export * from "./LivesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports